import { Flex, useDisclosure } from "@chakra-ui/react";
import { FieldProps, RJSFSchema } from "@rjsf/utils";

import { RanaButton, TrashIcon } from "@nens/ranalib";

import { FoldersBreadcrumb } from "@/components/folders-breadcrumb";
import { ProcessFile } from "@/features/project-process-run";

import { OutputDestinationNameModal } from "./components/output-destination-name-modal";
import { ProcessRunFormFileActionLabel } from "./components/process-run-form-file-action-label";
import { SelectFileOrDirectoryModal } from "./components/select-file-or-directory-modal";
import { getFileModalMode, isOutputMode } from "./utils/file-modal-mode";

export const getDefaultFileRef = (schema: RJSFSchema) => {
  const ref = schema.properties?.ref;
  if (!ref || typeof ref === "boolean") return "";
  return ref.default + "";
};

export function ProcessRunFormFile(props: FieldProps<ProcessFile>) {
  const { disabled, readonly, formData, schema, onChange } = props;
  const { isOpen, onClose, onOpen } = useDisclosure();

  const mode = getFileModalMode(schema, props.uiSchema);
  const isOutput = isOutputMode(mode);
  return (
    <>
      {isOpen && isOutput && (
        <OutputDestinationNameModal mode={mode} onClose={onClose} {...props} />
      )}
      {isOpen && !isOutput && (
        <SelectFileOrDirectoryModal mode={mode} onClose={onClose} {...props} />
      )}

      <Flex alignItems="center" gap={2}>
        {!disabled && !readonly && (
          <RanaButton variant="secondary" onClick={onOpen} mt="1">
            <ProcessRunFormFileActionLabel mode={mode} hasValue={!!formData?.id} />
          </RanaButton>
        )}
        {formData?.id && (
          <>
            <FoldersBreadcrumb paths={formData.id.split("/")} />
            {!disabled && !readonly && (
              <RanaButton onClick={() => onChange(undefined)} variant="tertiary">
                <TrashIcon color="red" />
              </RanaButton>
            )}
          </>
        )}
      </Flex>
    </>
  );
}
